import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Common from "../based/Common";
import CommonTablePagination from "../based/CommonTablePagination";
import { INITPAGING, NOTIFY, PLATFORM } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import { Notify } from "../based/Notify";
import ReadyListServices from "../based/services/ReadyListServices";
import Copy from "./assets/Copy.svg";
import OpenLink from "./assets/OpenLink.svg";
import { RequestDomain } from "../based/RequestDomain";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Ranus from "./assets/Ranus.svg";
import Tiktok from "./assets/Tiktok.svg";
import PayAlreadyModal from "./PayAlreadyModal";

const ReadyListStatus = {
    NotClick: 0,
    Clicked: 1,
    Confirmed: 2,
};

const ProductTab = {
    ListProduct: 0,
    Order: 1,
    Archive: 2,
};

const PlatformOptions = [
    {
        value: PLATFORM.Internal,
        label: "Ranus",
        image: Ranus,
    },
    {
        value: PLATFORM.Tiktok,
        label: "Tiktok",
        image: Tiktok,
    },
];

function ManageReadyToShipList(props) {
    const today = new Date();
    const tomorow = new Date(today);
    tomorow.setDate(tomorow.getDate() + 1);
    const history = useHistory();
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, orderDirection: "desc", fromDate: new Date(2025, 0, 1), toDate: tomorow, platform: PLATFORM.Internal });
    const [showPayAlreadyModal, setShowPayAlreadyModal] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(0);

    useEffect(() => {
        getDatas(paging);
    }, []);

    const getDatas = async (page) => {
        const [err, data] = await ReadyListServices.GetReadyListByPage(page);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setPaging(page);
        }
    };

    const setIsDelete = async (id) => {
        const [err, data] = await ReadyListServices.SetIsDelete(id);
        if (!err && data) {
            getDatas(paging);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Xóa thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
        }
    };

    const setIsArchive = async (id) => {
        const [err, data] = await ReadyListServices.SetIsArchive(id);
        if (!err && data) {
            getDatas(paging);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Archive thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
        }
    };

    const handleClone = async (id) => {
        const [err, data] = await ReadyListServices.CloneReadyList(id);
        if (!err && data) {
            getDatas(paging);
            window.open(`/ready-to-ship-list/${data.id}`, "_blank");
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Clone thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Có lỗi xảy ra");
        }
    };

    function renderBody() {
        let content = [];
        if (!datas || datas.length === 0) return "";

        datas.map((order, index) => {
            let firstColumn = [];
            let lastColumn = [];
            let rowSpan = order.groupItems && order.groupItems.length;

            //thông tin khách hàng
            firstColumn.push(
                <td rowSpan={rowSpan}>
                    <div className="list-info">
                        <div className="info-item">
                            <span className="title">Tên</span>
                            <input type="text" className="edit-content disabled" value={order.customerName} readOnly />
                        </div>
                        <div className="info-item">
                            <span className="title">Link HT</span>
                            <input type="text" className="edit-content" rows={3} value={order.facebookId} readOnly />
                        </div>
                        <div className="info-item">
                            <span className="title">TG Tạo</span>
                            <span className="edit-content">{Common.formatDate(new Date(order.createdDate), "fulldate")}</span>
                        </div>
                        {order.updatedDate && (
                            <div className="info-item">
                                <span className="title">TG Đặt</span>
                                <span className="edit-content">{Common.formatDate(new Date(order.updatedDate), "fulldate")}</span>
                            </div>
                        )}
                        {order.status != ReadyListStatus.Confirmed && (
                            <div
                                className="info-item cursor-pointer"
                                onClick={(e) => {
                                    navigator.clipboard.writeText(`${RequestDomain.HomeUrl()}/checkout-ready/${order.id}?paymentMethod=${order.payment}`);
                                    Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Copy link thành công");
                                }}
                            >
                                <span className="title">Link giỏ hàng</span>
                                <div className="link-flex">
                                    <span className="edit-content link">{`${RequestDomain.HomeUrl()}/checkout-ready/${order.id}?paymentMethod=${order.payment}`}</span>
                                    <div className="icon">
                                        <img src={Copy} alt="" />
                                    </div>
                                </div>
                            </div>
                        )}
                        {order.orderNumber && (
                            <div
                                className="info-item cursor-pointer"
                                onClick={(e) => {
                                    navigator.clipboard.writeText(`${RequestDomain.HomeUrl()}/ready-confirm-order/${order.orderNumber}`);
                                    Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Copy link thành công");
                                }}
                            >
                                <span className="title">Link xác nhận đơn hàng</span>
                                <div className="link-flex">
                                    <span className="edit-content link">{`${RequestDomain.HomeUrl()}/ready-confirm-order/${order.orderNumber}`}</span>
                                    <div className="icon">
                                        <img src={Copy} alt="" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </td>
            );

            //địa chỉ
            lastColumn.push(
                <td className="address-inf" rowSpan={rowSpan}>
                    {order.readyListShip && (
                        <React.Fragment>
                            <div className="address-info">
                                <span className="title">Tên</span>
                                <span className="edit-content">{order.readyListShip.userName}</span>
                            </div>
                            <div className="address-info">
                                <span className="title">SĐT</span>
                                <span className="edit-content">{order.readyListShip.phoneNumber}</span>
                            </div>
                            <div className="address-info">
                                <span className="title">Địa chỉ</span>
                                <span className="edit-content">{order.readyListShip.address}</span>
                            </div>
                            <div className="address-info">
                                <span className="title">Phường/Xã</span>
                                <span className="edit-content">{order.readyListShip.wardName}</span>
                            </div>
                            <div className="address-info">
                                <span className="title">Quận/Huyện</span>
                                <span className="edit-content">{order.readyListShip.districtName}</span>
                            </div>
                            <div className="address-info">
                                <span className="title">Tỉnh/Thành phố</span>
                                <span className="edit-content">{order.readyListShip.provinceName}</span>
                            </div>
                        </React.Fragment>
                    )}
                </td>
            );

            //thanh toán
            lastColumn.push(
                <td className="payment-inf" rowSpan={rowSpan}>
                    <div className="payment-info">
                        <span className="title">Phương thức thanh toán</span>
                        <span className="edit-content">{order.paymentName}</span>
                    </div>
                    <div className="payment-info">
                        <span className="title">Tổng tiền</span>
                        <span className="edit-content">{Common.formatCurrency(order.finnallyPrice)}</span>
                    </div>
                    <div className="payment-info">
                        <span className="title">Đã thanh toán</span>
                        <span className="edit-content">{Common.formatCurrency(order.transferPartial)}</span>
                    </div>
                    <div className="payment-info">
                        <span className="title">Còn lại</span>
                        <span className="edit-content">{Common.formatCurrency(order.finnallyPrice - order.transferPartial)}</span>
                    </div>
                    <div
                        className={`payment-already ${order.transferPartial > 0 ? "active" : ""}`}
                        onClick={(e) => {
                            e.preventDefault();
                            setShowPayAlreadyModal(true);
                            setSelectedOrderId(order.orderId);
                        }}
                    >
                        <span>
                            Khách đã thanh toán
                            {order.transferPartial > 0 ? <i className="fa fa-check"></i> : ""}
                        </span>
                    </div>
                </td>
            );

            //trạng thái
            lastColumn.push(
                <td className="vertical-align-middle" rowSpan={rowSpan}>
                    <div className="status-info">
                        <span className="status">{order.statusName}</span>
                    </div>
                    {order.orderId > 0 && (
                        <div className="order-info">
                            <span className="title">Người đặt:</span>
                            <span className={`edit-content ${order.isSystem ? "danger" : ""}`}>{order.isSystem ? `Hệ thống (${order.customerUserName})` : "Khách hàng"}</span>
                        </div>
                    )}
                    {order.orderId > 0 && (
                        <div className="order-info">
                            <span className="title">Mã Ranus:</span>
                            <span className="edit-content">
                                <div
                                    className="icon cursor-pointer"
                                    onClick={(e) => {
                                        window.open(`https://admin.ranus.vn/order-detail/${order.orderId}`, "_blank");
                                    }}
                                >
                                    {order.orderId}
                                    <img src={OpenLink} />
                                </div>
                            </span>
                        </div>
                    )}
                    {order.orderNumber != "" && (
                        <div className="order-info">
                            <span className="title">Mã đơn hàng:</span>
                            <span
                                className="edit-content cursor-pointer"
                                onClick={(e) => {
                                    navigator.clipboard.writeText(order.orderNumber);
                                    Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Copy mã đơn hàng thành công");
                                }}
                            >
                                {order.orderNumber}
                            </span>
                        </div>
                    )}
                    {order.orderStatusName != "" && (
                        <div className="order-info">
                            <span className="title">Trạng thái đơn hàng:</span>
                            <span className="edit-content cursor-pointer">{order.orderStatusName}</span>
                        </div>
                    )}
                    {order.remarks != "" && order.remarks != null && (
                        <div className="order-info">
                            <span className="title">Ghi chú:</span>
                            <span className="edit-content">{order.remarks}</span>
                        </div>
                    )}
                </td>
            );

            //hành động
            lastColumn.push(
                <td className="center" rowSpan={rowSpan}>
                    <div className="lst-action-item">
                        <button
                            className={`btn btn-custom m-1 ${order.status == ReadyListStatus.Confirmed ? "disabled" : ""}`}
                            onClick={(e) => {
                                e.preventDefault();
                                history.push(`/ready-to-ship-list/${order.id}`);
                            }}
                        >
                            Sửa
                        </button>
                        <button
                            className={`btn btn-custom m-1`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleClone(order.id);
                            }}
                        >
                            Clone
                        </button>
                        {paging.productTab != ProductTab.Archive && (
                            <button
                                className="btn btn-custom m-1"
                                onClick={(e) => {
                                    setIsArchive(order.id);
                                }}
                            >
                                Lưu trữ
                            </button>
                        )}
                        <button
                            className={`btn btn-danger m-1`}
                            onClick={(e) => {
                                new ConfirmDialog("Xác nhận xóa", "Bạn có chắc chắn muốn xóa list này?", () => {
                                    return new Promise((resolve, reject) => {
                                        setIsDelete(order.id);
                                        resolve({ title: "Thành công", msg: "Xóa thành công." });
                                    });
                                });
                            }}
                        >
                            Xóa
                        </button>
                    </div>
                </td>
            );

            //danh sách sản phẩm
            let productColumn = [];
            if (order.groupItems)
                order.groupItems.map((product, index) => {
                    let productContent = [];
                    //hình
                    productContent.push(
                        <td>
                            <div className="list-item-thumbnail">
                                {product.templateImages &&
                                    product.templateImages.map((i, x) => {
                                        let image = i.productImageUrl ? i.productImageUrl.replace(".jpg", "_crop.webp") : "";
                                        if (!image) return "";
                                        return <img src={image} alt="" className="thumbnail" key={x} />;
                                    })}
                            </div>
                        </td>
                    );
                    //sản phẩm
                    productContent.push(
                        <td>
                            <div className="product-detail-info">
                                <div className="product-name">{product.designTitle}</div>
                                <div className="product-attr">
                                    {product.appProductName}, {product.colorDisplayName}
                                </div>
                                <div className="product-lst">
                                    {product.readyListItems &&
                                        product.readyListItems.map((i, x) => {
                                            return (
                                                <span className="badge badge-custom" key={x}>
                                                    {i.sizeValue}x{i.quantity}
                                                </span>
                                            );
                                        })}
                                </div>
                            </div>
                        </td>
                    );
                    productColumn.push(productContent);
                });

            //ghép các phần lại với nhau
            productColumn.map((product, idx) => {
                if (idx == 0) {
                    content.push(
                        <tr id={`${index}_o${idx}`} key={`${index}_o${idx}`}>
                            {firstColumn.map((i) => i)}
                            {product.map((i) => i)}
                            {lastColumn.map((i) => i)}
                        </tr>
                    );
                } else {
                    content.push(
                        <tr id={`${index}_o${idx}`} key={`${index}_o${idx}`}>
                            {product.map((i) => i)}
                        </tr>
                    );
                }
            });
        });
        return content;
    }

    function _renderBody() {
        if (datas && datas.length > 0) return <tbody>{renderBody()}</tbody>;
        else
            return (
                <tbody>
                    <tr>
                        <td colSpan="999" className="vertical-align-middle text-center">
                            Không có dữ liệu
                        </td>
                    </tr>
                </tbody>
            );
    }

    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        label: "Trang chủ",
                        value: "/",
                    },
                    {
                        label: "Quản lý đơn trực tiếp",
                        value: "/manage-ready-to-ship-list",
                    },
                ]}
                title={"Quản lý đơn trực tiếp"}
            />
            <Wrapper>
                <section className="list-platform">
                    <div className="list-nav-item">
                        {PlatformOptions.map((item, index) => {
                            return (
                                <span
                                    className={`cursor-pointer nav-location ${paging.platform == item.value ? "active" : ""}`}
                                    key={index}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        getDatas({ ...paging, platform: item.value, pageNumber: 1 });
                                    }}
                                >
                                    <img src={item.image} alt="" className="icon" />
                                </span>
                            );
                        })}
                    </div>
                </section>
                <section className="action-list">
                    {paging.platform == PLATFORM.Internal && (
                        <button
                            className="btn btn-add-order"
                            onClick={(e) => {
                                e.preventDefault();
                                history.push("/ready-to-ship-list");
                            }}
                        >
                            Tạo đơn hàng
                        </button>
                    )}
                </section>

                <section className="table-manage">
                    <div className="list-nav-item">
                        {paging.platform == PLATFORM.Internal && (
                            <React.Fragment>
                                <span className="nav-item">
                                    <a
                                        className={`nav-link ${paging.productTab == ProductTab.ListProduct ? "active" : "btn-light"}`}
                                        onClick={() => {
                                            getDatas({ ...paging, productTab: ProductTab.ListProduct, pageNumber: 1 });
                                        }}
                                    >
                                        <span>Quản lý đơn</span>
                                    </a>
                                </span>
                                <span className="nav-item">
                                    <a
                                        className={`nav-link ${paging.productTab == ProductTab.Order ? "active" : "btn-light"}`}
                                        onClick={() => {
                                            getDatas({ ...paging, productTab: ProductTab.Order, pageNumber: 1 });
                                        }}
                                    >
                                        <span>Đã đặt hàng</span>
                                    </a>
                                </span>
                                <span className="nav-item">
                                    <a
                                        className={`nav-link ${paging.productTab == ProductTab.Archive ? "active" : "btn-light"}`}
                                        onClick={() => {
                                            getDatas({ ...paging, productTab: ProductTab.Archive, pageNumber: 1 });
                                        }}
                                    >
                                        <span>Lưu trữ</span>
                                    </a>
                                </span>
                            </React.Fragment>
                        )}
                    </div>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th className="center" width="15%">
                                    Thông tin khách hàng
                                </th>
                                <th className="center">Hình</th>
                                <th className="center" width="15%">
                                    Sản phẩm
                                </th>
                                <th className="center" width="15%">
                                    Địa chỉ
                                </th>
                                <th className="center">Thanh toán</th>
                                <th className="center">Trạng thái</th>
                                <th className="center"></th>
                            </tr>
                        </thead>
                        {_renderBody()}
                    </table>
                    <CommonTablePagination
                        paging={paging}
                        onChangePage={(page) => {
                            getDatas({ ...paging, pageNumber: page });
                        }}
                        onChangePageSize={(pageSize) => {
                            getDatas({ ...paging, pageNumber: 1, pageSize: pageSize });
                        }}
                        withoutTable
                    />
                </section>
            </Wrapper>
            <PayAlreadyModal
                show={showPayAlreadyModal}
                onClose={() => {
                    setShowPayAlreadyModal(false);
                }}
                onSave={() => {
                    setShowPayAlreadyModal(false);
                    getDatas(paging);
                }}
                orderId={selectedOrderId}
            />
        </React.Fragment>
    );
}

export default ManageReadyToShipList;

const Wrapper = styled.div`
    margin: 16px 32px;
    width: calc(100% - 64px);

    .payment-already.active span i {
        margin-left: 5px;
    }

    .payment-already.active {
        border-radius: 8px;
        background: #fff5ec;
    }

    .payment-already.active span {
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .payment-already {
        border-radius: 8px;
        background: #ff9027;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 6px 12px;
        cursor: pointer;
    }

    .payment-already span {
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .list-nav-item {
        min-height: 34px;
    }

    section.action-list {
        min-height: 34px;
    }
    section.list-platform {
        margin: 12px 0 12px 0;
    }

    .nav-location {
        margin-right: 24px;
        padding-bottom: 12px;
    }

    .nav-location.active {
        border-bottom: 2px solid #ff9027;
    }

    .link-flex {
        display: flex;
        align-items: center;
        color: #2673dd;
    }

    .link-flex span {
        color: #2673dd !important;
    }

    .list-info {
        overflow: hidden;
    }

    .info-item input.edit-content {
        width: 100%;
    }

    button.btn.btn-add-order {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .list-item {
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    button.btn.btn-custom {
        border-radius: 40px;
        background: #ff9027;
        border: none;
    }

    section.table-manage {
        margin: 10px 0;
    }

    .list-nav-item {
        display: flex;
        align-items: center;
    }

    a.nav-link {
        background: #fff;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 8px;
    }

    a.nav-link.active {
        border-radius: 8px;
        background: #fff5ec;
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    span.nav-item {
        margin: 0 5px;
    }

    table.table {
        margin: 10px 0;
        border-radius: 12px;
        border: none;
        background: #fff;
        overflow: hidden;
    }

    thead tr th {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 16px 16px !important;
        border: none !important;
    }

    .list-item-thumbnail {
        display: flex;
    }

    .list-item-thumbnail img.thumbnail {
        width: 70px;
        height: 70px;
        border-radius: 6px;
        overflow: hidden;
        object-fit: contain;
    }

    .info-item {
        display: flex;
        align-items: center;
        margin: 8px 0;
    }

    .list-info .info-item span.title {
        width: 30%;
        flex-shrink: 0;
        flex-grow: 0;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    span.edit-content.link {
        flex: 1;
    }

    .list-info .info-item textarea.edit-content {
        flex: 1;
    }

    .list-info .info-item input {
        flex: 1;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        background: #fff;
    }

    span.edit-content {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .product-name {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .product-attr {
        overflow: hidden;
        color: #a0a0a0;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 10px 0;
    }

    span.badge.badge-custom {
        border-radius: 50px;
        background: #303030;
        overflow: hidden;
        color: #fff;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span.title {
        overflow: hidden;
        color: #a4a4a4;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .address-info {
        display: flex;
        align-items: center;
        margin: 8px 0;
    }

    .address-info span.title {
        width: 30%;
        flex-shrink: 0;
        flex-grow: 0;
    }

    .payment-info {
        display: flex;
        margin: 8px 0;
    }

    .payment-info span.title {
        width: 50%;
        flex-shrink: 0;
        flex-grow: 0;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .status-info {
        display: flex;
        margin: 8px 0;
    }

    .order-info {
        display: flex;
        align-items: center;
        margin: 8px 0;
    }

    .order-info span.title {
        width: 30%;
        flex-shrink: 0;
        flex-grow: 0;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .lst-action-item {
        display: flex;
        flex-direction: column;
    }

    .lst-action-item button {
        background: none !important;
        color: #303030 !important;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        border: none !important;
    }
`;
